import {Injectable} from '@angular/core';
import {CheckListStrategy} from './check-list.strategy';
import {Checkpoint} from '../../../data/checkpoint.model';
import {CheckpointStage} from '../../../data/checkpoint-stage.enum';
import {CheckpointType} from '../../../data/checkpoint-type.enum';


@Injectable()
export class AssignCheckListStrategy implements CheckListStrategy {

  availableTypes: CheckpointType[] = [CheckpointType.Assignment];
  stage = CheckpointStage.Check;
  getDefaultValue(): Partial<Checkpoint> {
    return {
      type: CheckpointType.Assignment
    };
  }
}
